<template>
  <jt-card-default
    :shouldShowSelectMonth="false"
    :cardSelectType="0"
    @change="onChangeSelectBar"
  >
    <div v-if="isLoadingBar" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-bar-chart
      v-else
      centralTitleConst="DASHBOARD_BILLING_RECEIPT_TON_MONTH"
      class="editCss"
      :data="collectionsData"
      :xAxisData="collectionsColumn"
      :shouldShowOverlappingBars="false"
      :yAxisIndexNames="['ton','min']"
      yAxisNameConst="DASHBOARD_BILLING_RECEIPT_TON_MONTH"
    />
  </jt-card-default>
</template>

<script>
import JtEmptyMessage from 'jtech-webcomps'
import JtBarChart from 'src/components/charts/JtBarChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'ReceiptTon',
  components: {
    JtCardDefault,
    JtBarChart,
    JtEmptyMessage
  }
})
export default class ReceiptTon extends Vue {
  isLoadingBar = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  registers = [];
  collectionsColumn = [];
  collectionsData = [];

  async onChangeSelectBar (date) {
    this.isLoadingBar = true

    const monthValuesProjected = await this.getProjectedMonths(date)

    this.registers = await this.getDoughnutData(date)

    const monthValues = Array.from({ length: 12 }, (item, index) => 0)
    const monthAvgTimeDischargeValues = Array.from({ length: 12 }, (item, index) => 0)

    this.registers.forEach(register => {
      monthValues[register.month - 1] = parseInt(parseFloat(register.ton.replaceAll('.', '')) / 1000)
      monthAvgTimeDischargeValues[register.month - 1] = parseInt(register.time)
    })

    moment.locale('pt')
    this.collectionsColumn = moment.monthsShort()

    this.collectionsData = [
      {
        data: monthValues,
        name: this.$gettext('DASHBOARD_BILLING_REAL'),
        type: 'bar',
        yAxisIndex: 0

      },
      {
        data: monthValuesProjected,
        name: this.$gettext('DASHBOARD_BILLING_BUDGETED'),
        type: 'bar',
        yAxisIndex: 0

      },
      {
        data: monthAvgTimeDischargeValues,
        name: this.$gettext('DASHBOARD_BILLING_AVG_TIME_OUTFLOW'),
        type: 'line',
        yAxisIndex: 1
      }

    ]

    setTimeout(() => {
      this.isLoadingBar = false
    }, 500)
  }

  async getProjectedMonths (date) {
    const monthValuesProjected = Array.from({ length: 12 }, (item, index) => '0')

    const { registros } = await repository.resolveDatatableModel(
      'projectedMonth.pesquisar',
      {
        grid: 'pesquisa',
        projectedMonthType: 20450001,
        year: date.year
      }
    )
    if (registros.length != 0) {
      const projectedMonth = registros[0]
      monthValuesProjected[0] = (projectedMonth.jan ? projectedMonth.jan : '0')
      monthValuesProjected[1] = (projectedMonth.feb ? projectedMonth.feb : '0')
      monthValuesProjected[2] = (projectedMonth.mar ? projectedMonth.mar : '0')
      monthValuesProjected[3] = (projectedMonth.apr ? projectedMonth.apr : '0')
      monthValuesProjected[4] = (projectedMonth.may ? projectedMonth.may : '0')
      monthValuesProjected[5] = (projectedMonth.jun ? projectedMonth.jun : '0')
      monthValuesProjected[6] = (projectedMonth.jul ? projectedMonth.jul : '0')
      monthValuesProjected[7] = (projectedMonth.aug ? projectedMonth.aug : '0')
      monthValuesProjected[8] = (projectedMonth.sep ? projectedMonth.sep : '0')
      monthValuesProjected[9] = (projectedMonth.oct ? projectedMonth.oct : '0')
      monthValuesProjected[10] = (projectedMonth.nov ? projectedMonth.nov : '0')
      monthValuesProjected[11] = (projectedMonth.dec ? projectedMonth.dec : '0')

      monthValuesProjected.forEach((register, index) => {
        monthValuesProjected[index] = parseInt(parseFloat(register.replaceAll('.', '')))
      })
    }
    return monthValuesProjected
  }

  async created () {
    await this.onChangeSelectBar(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'receiptTon',
        year: date.year
      }
    )
    return registros
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
